import defaultAttributes from '../defaultAttributes';

const ChevronLeft = [
  'svg',
  defaultAttributes,
  [['polyline', { points: '15 18 9 12 15 6' }]],
];

export default ChevronLeft;
